module.exports = __webpack_public_path__ + "3b767b0856471e4e0826659b5dafbc57.svg";